<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params)">
        <span>{{ organizationTypeString(params) }}</span>
    </vs-chip>
</template>

<script>
export default {
    name: "CellRendererLeaveType",
    computed: {
        chipColor() {
            return value => {
                if (parseInt(value.data.leaveType, 10) === 0) {
                    return "success"
                } else if (parseInt(value.data.leaveType, 10) === 1) {
                    return "warning"
                }
            }
        },
        organizationTypeString() {
            return value => {
                if (parseInt(value.data.leaveType, 10) === 0) {
                    return "Nghỉ có phép"
                } else if (parseInt(value.data.leaveType, 10) === 1) {
                    return "Nghỉ không phép"
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
